import { render, staticRenderFns } from "./CopyTraineeSchedule.vue?vue&type=template&id=3a568ff8"
import script from "./CopyTraineeSchedule.vue?vue&type=script&lang=js"
export * from "./CopyTraineeSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports